import { useTranslation } from 'react-i18next'

import { NOTIFICATION_TYPE } from '../../../../../constants/common'
import { useDate, useDateLimits, useScreen } from '../../../../../hooks'
import { DateTimePicker } from '../../../../DateTime'
import { FormFieldsContainer, FormFieldSelectNG } from '../../../../Form'
import { FormikField, getFormikFormFieldErrorProps } from '../../../../Formik'
import { NotificationInline } from '../../../../Notification'
import { toViewingFormDurationOptions } from '../../../../RentalPortalViewing'
import { InputSelect } from '../../../../Select'
import { VIEWING_RESCHEDULE_FIELD_NAME } from '../ViewingRescheduleModal.constants'

function ViewingRescheduleModalFields() {
  const { t } = useTranslation()

  const { isMobileScreenSize } = useScreen()

  const { maxDate } = useDateLimits()

  const date = useDate()

  return (
    <FormFieldsContainer>
      <NotificationInline
        text={t('RentalPortal.ViewingRescheduleNoticeKey')}
        type={NOTIFICATION_TYPE.info}
      />
      <FormikField
        Component={DateTimePicker}
        borderless={!isMobileScreenSize}
        dateProps={{
          placeholder: t('RentalPortal.ListingFormDatePlaceholderKey'),
        }}
        fieldComponentProps={{
          label: `${t('RentalPortal.ViewingFormStartLabelKey')}:`,
          required: true,
          shouldAdaptToMobileScreen: true,
        }}
        maxValue={maxDate}
        minValue={date}
        name={VIEWING_RESCHEDULE_FIELD_NAME.start}
        timeProps={{
          placeholder: t('RentalPortal.ListingFormTimePlaceholderKey'),
        }}
      />
      <FormikField
        Component={FormFieldSelectNG}
        Select={InputSelect}
        controlProps={{
          borderless: !isMobileScreenSize,
          contentProps: {
            inputProps: {
              placeholder: t('RentalPortal.ViewingFormDurationPlaceholderKey'),
            },
          },
        }}
        emptyValue={null}
        fieldComponentProps={{
          label: `${t('RentalPortal.ViewingFormDurationLabelKey')}:`,
          required: true,
          shouldAdaptToMobileScreen: true,
        }}
        getErrorProps={getFormikFormFieldErrorProps}
        name={VIEWING_RESCHEDULE_FIELD_NAME.duration}
        options={toViewingFormDurationOptions(t)}
      />
    </FormFieldsContainer>
  )
}

export default ViewingRescheduleModalFields
